import { appConfig, appEnvironments } from "@/config";

export const getAppConfig = (): IAppEnvironmentConfig => {
  const environment = getCurrentEnvironmentDomain();
  const config: IAppConfig = appConfig;

  return config[environment];
};

export const getCurrentEnvironment = (): IAppEnvironments => {
  const config = getAppConfig();

  return config?.env || "dev";
};


export const getCurrentEnvironmentDomain = (): IAppEnvironmentDomains => {
  const environmentMapping = appEnvironments;
  const currentHostname = window.location.hostname;

  return environmentMapping[currentHostname] || "development";
};
